import React from "react";

const ReplayIcon = ({ handleClick, extraClasses, size = "small" }) => {
  return (
    <button
      role="img"
      onClick={handleClick}
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
      <span className={`oc-o-icon-next-video icon-svg fa-icon-svg--${size}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
          <defs>
            <path id="a" d="M0 0h23.62v22.4H0z" />
            <path id="c" d="M0 0h23.62v22.4H0z" />
          </defs>
          <g fill="none" fillRule="evenodd">
            <g transform="translate(8 9.33)">
              <mask id="b" fill="#fff">
                <use xlinkHref="#a" />
              </mask>
              <path fill="#FFF" d="M12.41 0C8.12 0 4.25 2.48 2.38 6.27L1.23 1.69 0 2l1.7 6.72 6.72-1.7-.31-1.22-4.67 1.18a9.95 9.95 0 018.97-5.72 9.95 9.95 0 010 19.89c-3.65 0-7-2-8.74-5.2l-1.1.6A11.2 11.2 0 1012.4 0" mask="url(#b)" />
            </g>
            <g transform="translate(8 9.33)">
              <mask id="d" fill="#fff">
                <use xlinkHref="#c" />
              </mask>
              <path fill="#FFF" d="M12.41 0C8.12 0 4.25 2.48 2.38 6.27L1.23 1.69 0 2l1.7 6.72 6.72-1.7-.31-1.22-4.67 1.18a9.95 9.95 0 018.97-5.72 9.95 9.95 0 010 19.89c-3.65 0-7-2-8.74-5.2l-1.1.6A11.2 11.2 0 1012.4 0" mask="url(#d)" />
            </g>
          </g>
        </svg>
      </span>
    </button>
  );
};

export default ReplayIcon;
